module.exports = __webpack_public_path__ + "img/detail_livelist_playicon.038c08af.png";